/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import { ResponsiveLine } from '@nivo/line';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import styles from './NivoLineChart.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

type TypeNivoLineChart = {
  data: Object,
  widgetSize: string,
};

export default class NivoLineChart extends React.Component<*> {
  render(): React.Element<*> {
    const { data, widgetSize, ...restProps }: TypeNivoLineChart = this.props;

    const margin: { [key: string]: number } =
      widgetSize === 'thumbnail' ? { top: 0 } : { top: 5, right: 10, bottom: 53, left: 50 };

    const lineWidth: number = widgetSize === 'thumbnail' ? 2 : 3;
    const isInteractive: boolean = widgetSize !== 'thumbnail';

    return (
      <ResponsiveLine
        data={data}
        margin={margin}
        minY="auto"
        axisLeft={{
          orient: 'left',
          tickSize: 0,
          tickPadding: 25,
          tickRotation: 0,
        }}
        axisBottom={{
          orient: 'bottom',
          tickSize: 0,
          tickPadding: 10,
          tickRotation: -90,
        }}
        enableGridY={false}
        enableGridX={isInteractive}
        colorBy={(e: Object) => {
          return e.color;
        }}
        lineWidth={lineWidth}
        enableDots={false}
        animate={false}
        motionStiffness={90}
        motionDamping={15}
        isInteractive={isInteractive}
        {...restProps}
      />
    );
  }
}
